const  seriesPlayTimeColor = {
    normal: ["#A4D65F", "#CA2AB1", "#67B3EB"],
};
const  seriesContentColor = {
    normal: ["#67B3EB", "#A4D65F", "#48C6CB", "#C92BB1", "#457BDB", "#C6652B"]
};

const seriesClassUseColor = ["#ffba00"];

module.exports = {
    seriesPlayTimeColor,
    seriesContentColor,
    seriesClassUseColor,

    seriesClassUseChart: [
        { name: "전체", field: "divisionTotal", stack: "base", option: { itemStyle: { color: seriesClassUseColor[0] } } },
    ],
    seriesChildUseChart: [
        { name: "활동 결과물 저장", field: "playResultCount", stack: "base", option: { itemStyle: { color: "#8ddfd4" } } },
        { name: "포트폴리오 전송", field: "sendHomeCount", stack: "base1", option: { itemStyle: { color: "#d4c3f5" } } },
    ],
    seriesAgeUseChart: [
        { name: "만3세", field: "age1", stack: "base0", showSum: false },
        { name: "만4세", field: "age2", stack: "base1", showSum: false },
        { name: "만5세", field: "age3", stack: "base2", showSum: false },
        { name: "혼합", field: "age123", stack: "base3", showSum: false },
    ],
    seriesContentUseChart: [
        { name: "딩동수업", field: "playNormal", stack: "base", showSum: false },
        { name: "딩동AR", field: "playAR", stack: "base", showSum: false },
        { name: "협동그림", field: "playCollabo", stack: "base", showSum: false },
        { name: "OX퀴즈", field: "playOX", stack: "base", showSum: false },
    ],
    seriesContractChart: [
        { name: "계약 원아 수", field: "childContract", stack: "base0", showSum: false, option: { itemStyle: { color: "#EBD834" }}},
        { name: "등록 원아 수", field: "childJoin", stack: "base1", showSum: false, option: { itemStyle: { color: "#A1D852" } }},
    ]
};